import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  sipStartInfo: {
    textAlign: "center",
  },
};
